import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import useHistory from "routing/useHistory";
import { Row, Col, Button } from "components/bootstrap";
import { DocumentTitle, PageHeader, Icon } from "components/common";
import IndicesPageNavigation from "components/indices/IndicesPageNavigation";
import DocsHelper from "util/DocsHelper";
import ArchiveRoutes from "archive/Routes";
import ArchiveIndexSetConfigurationForm from "./components/ArchiveIndexSetConfigurationForm";
const HeaderTitle = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.sm};
    margin-bottom: ${theme.spacings.xs};
  `
);
const RestoredIndexSetConfigurationPage = () => {
  const { push } = useHistory();
  const { t } = useTranslation("enterprise_archive");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("archive_index_set_configuration_page.document_title") }, /* @__PURE__ */ React.createElement(IndicesPageNavigation, null), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: /* @__PURE__ */ React.createElement(HeaderTitle, null, /* @__PURE__ */ React.createElement(Button, { onClick: () => push(ArchiveRoutes.INDEX_SET.SHOW) }, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_left_alt", size: "sm" }), " ", t("archive_index_set_configuration_page.back")), t("archive_index_set_configuration_page.page_title")),
      documentationLink: {
        title: t("archive_index_set_configuration_page.documentation_link_title"),
        path: DocsHelper.PAGES.INDEX_MODEL
      }
    }
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ArchiveIndexSetConfigurationForm, null)))));
};
export default RestoredIndexSetConfigurationPage;
